import { RefObject } from 'react';
import { SignatureCanvas } from '~/modules';
import {
  ButtonContainer,
  ButtonWrapper,
  ClearButton,
  ConfirmButton,
  Container,
  SignatureContainer,
  StyledSignatureCanvas,
} from './styles';

interface OnboardingSignatureProps {
  signatureRef: RefObject<SignatureCanvas>;
  onClear: () => void;
  onConfirm: () => void;
  isConfirmButtonEnabled: boolean;
  onEnd: () => void;
}

const OnboardingSignature = ({
  signatureRef,
  onClear,
  onConfirm,
  isConfirmButtonEnabled,
  onEnd,
}: OnboardingSignatureProps) => {
  return (
    <Container>
      <SignatureContainer>
        <StyledSignatureCanvas
          ref={signatureRef}
          penColor="black"
          onEnd={onEnd}
        />
      </SignatureContainer>
      <ButtonWrapper>
        <ButtonContainer>
          <ClearButton id="clear-signature" onPress={onClear} transparent>
            LIMPAR
          </ClearButton>
          <ConfirmButton
            id="confirm-signature"
            onPress={onConfirm}
            disabled={!isConfirmButtonEnabled}
          >
            FICOU BOA
          </ConfirmButton>
        </ButtonContainer>
      </ButtonWrapper>
    </Container>
  );
};

export default OnboardingSignature;
